export const normalizeToString = (value: unknown): string => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value);
  if (typeof value === 'object') {
    try {
      if ('response' in (value as any)) {
        const resp = (value as any).response;
        return typeof resp === 'string' ? resp : JSON.stringify(resp);
      }
      return JSON.stringify(value);
    } catch (err) {
      return '';
    }
  }
  return '';
};
